import React, { ReactElement } from 'react';
import { BulkUploadDetailsSchemaContract } from 'schemas/BulkUploadDetailsSchema';
import { BulkUploadTypes } from 'constants/bulkUpload';
import { ReviewSectionItem } from 'components/WizardViews/components/review';
import { ReviewSectionContainer } from 'components/WizardViews/components/review';
import { ReviewSectionItemContainer } from 'components/WizardViews/components/review';
import { Box, CalendarIcon, Text } from '@razorpay/blade/components';
import { useBulkUploadType } from '../hooks/useBulkUploadType';

const getCustomRowTitle = (bulkUploadTypeRequest?: Number) => {
  if (bulkUploadTypeRequest && bulkUploadTypeRequest === BulkUploadTypes.TYPE_BULK_SALARY_REVISION)
    return 'Salary Revisions';

  return '';
};

export const BulkUploadSummary = ({
  bulkUploadRecord,
  isInputDataHidden = false,
}: {
  bulkUploadRecord: BulkUploadDetailsSchemaContract[0] | null;
  isInputDataHidden?: boolean;
}): ReactElement => {
  const bulkUploadTypeRequest = useBulkUploadType();
  const inputConfig = bulkUploadRecord?.input_config;
  let selectedDate = inputConfig?.payrollMonth
    ? new Date(inputConfig?.payrollMonth)
    : null;
  if (
    bulkUploadTypeRequest &&
    bulkUploadTypeRequest === BulkUploadTypes.TYPE_BULK_SALARY_REVISION
  ) {
    selectedDate = inputConfig?.effectiveMonth
      ? new Date(inputConfig?.effectiveMonth)
      : null;
  }
  const payrollMonth = selectedDate?.toLocaleString('default', { month: 'long' });

  return (
    <ReviewSectionContainer>
      <ReviewSectionItemContainer>
        <ReviewSectionItem
          label="File Details"
          value={bulkUploadRecord?.file_name ?? 'File Not Found'}
          status={'success'}
        />
        <ReviewSectionItem
          label="Total Rows"
          value={`${bulkUploadRecord?.total_number_of_rows ?? 0} ${getCustomRowTitle(
            bulkUploadTypeRequest,
          )}`}
          status={'success'}
        />
        {!isInputDataHidden && (
          <ReviewSectionItem
            label="Date"
            value={
              <Box display="flex" alignItems="center" gap="spacing.2">
                <CalendarIcon />
                {bulkUploadTypeRequest &&
                bulkUploadTypeRequest === BulkUploadTypes.TYPE_BULK_SALARY_REVISION ? (
                  <Text as="span" marginLeft="spacing.2">
                    Effective Month:{' '}
                    <Text as="span" weight="semibold">{`${
                      selectedDate
                        ? selectedDate.toLocaleDateString('en-us', {
                            year: 'numeric',
                            month: 'short',
                          })
                        : ''
                    }`}</Text>
                  </Text>
                ) : (
                  <Text as="span" marginLeft="spacing.2">
                    Payroll Month:{' '}
                    <Text as="span" weight="semibold">{`${selectedDate ? payrollMonth : ''}`}</Text>
                  </Text>
                )}
              </Box>
            }
            status={'success'}
          />
        )}
      </ReviewSectionItemContainer>
    </ReviewSectionContainer>
  );
};
